<h2 mat-dialog-title>Advanced search</h2>

<mat-dialog-content>
  <form id="form" (submit)="submit($event)">
    <p>
      <mat-form-field appearance="outline">
        <mat-label>search</mat-label>
        <input matInput type="text" [formField]="filterForm.q" spellcheck="false" />
      </mat-form-field>
    </p>
    <p>
      <app-form-control-autocomplete
        label="scientificName"
        (searchString)="scientificNameSearch.set($event)"
        [resource]="scientificNameResource"
        [multiple]="true"
        [formField]="filterForm.scientificName"
      />
    </p>
    @if (filterForm.scientificName.length) {
      <p>
        <mat-slide-toggle [formField]="filterForm.subtaxa">Include subtaxa</mat-slide-toggle>
      </p>
    }
    <p>
      <app-form-control-autocomplete
        label="lifeStage"
        (searchString)="lifeStageSearch.set($event)"
        [resource]="lifeStageResource"
        [multiple]="true"
        [formField]="filterForm.lifeStage"
      />
    </p>
    <p class="horizontal-group">
      <app-form-control-autocomplete
        label="expedition"
        (searchString)="expeditionSearch.set($event)"
        [resource]="expeditionResource"
        [multiple]="true"
        [formField]="filterForm.expedition"
      />
      <mat-form-field appearance="outline">
        <mat-label>fieldNumber</mat-label>
        <input matInput type="text" [formField]="filterForm.fieldNumber" />
      </mat-form-field>
    </p>
    <p class="horizontal-group">
      <app-form-control-autocomplete
        label="planktonType"
        (searchString)="planktonTypeSearch.set($event)"
        [resource]="planktonTypeResource"
        [formField]="filterForm.planktonType"
      />
      <app-form-control-autocomplete
        label="gearType"
        (searchString)="gearTypeSearch.set($event)"
        [resource]="gearTypeResource"
        [multiple]="true"
        [formField]="filterForm.gearType"
      />
    </p>
    <p class="horizontal-group">
      <mat-form-field appearance="outline">
        <mat-label>from</mat-label>
        <input matInput [matDatepicker]="fromPicker" [formField]="filterForm.from" />
        <mat-hint>YYYY-MM-DD</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>until</mat-label>
        <input matInput [matDatepicker]="untilPicker" [formField]="filterForm.until" />
        <mat-hint>YYYY-MM-DD</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="untilPicker"></mat-datepicker-toggle>
        <mat-datepicker #untilPicker></mat-datepicker>
      </mat-form-field>
    </p>

    <mat-card class="npdc-leaflet" appearance="outlined">
      <app-leaflet-group
        [geometry]="filterForm.geojson().value() || undefined"
        [readonly]="false"
        [height]="'400px'"
        (geometryChange)="onGeoSearch($event)"
      />
    </mat-card>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button type="submit" form="form">Filter</button>
  <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
